/** css */
import './GanttMassiveCompany.css';
import GanttMassiveCompany from './GanttMassiveCompany';

export default GanttMassiveCompany;
